class NnKeyConstants {
  // NnKeyConstants.notes is an array of the key names e.g. ['A', 'AsBf', ...]
  static get keyNames() {
    return Object.keys(NnKeyConstants.data);
  }

  static get octaves() {
    return ["1", "2", "3", "4", "5", "6"];
  }

  static get data() {
    return {
      C: { labelSharp: "C", labelFlat: "C" },
      CsDf: { labelSharp: "C#", labelFlat: "Db" },
      D: { labelSharp: "D", labelFlat: "D" },
      DsEf: { labelSharp: "D#", labelFlat: "Eb" },
      E: { labelSharp: "E", labelFlat: "E" },
      F: { labelSharp: "F", labelFlat: "Db" },
      FsGf: { labelSharp: "F#", labelFlat: "Gb" },
      G: { labelSharp: "G", labelFlat: "G" },
      GsAf: { labelSharp: "G#", labelFlat: "Ab" },
      A: { labelSharp: "A", labelFlat: "A" },
      AsBf: { labelSharp: "A#", labelFlat: "Bb" },
      B: { labelSharp: "B", labelFlat: "B" }
    };
  }
}
export default NnKeyConstants;



// WEBPACK FOOTER //
// ./src/NnKeyConstants.js